import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const contactModesReducer = (state = initialState.partnerContactModes, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_CONTACT_MODES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_PARTNER_CONTACT_MODES_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_PARTNER_CONTACT_MODES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_CONTACT_MODES_SUCCEEDED: {
      const { partnerId, ids } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: true, ids: ids };
      return result;
    }

    case types.PARTNER_CONTACT_MODES_INVALIDATED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: contactModesReducer
});
